module.exports = {
  message: {
    'hello': '你好'
  },
  btn: {
    text: '按钮'
  },
  common: {
  },
  header: {
    lang: '繁 / 简体',
    home: '首页',
    about: {
      index: '关于SFK',
      company: '公司简介',
      brand: {
        index: '品牌介绍',
        symbol: '品牌标志',
        idea: '品牌理念'
      },
      history: '发展历程'
    },
    main: '主营项目',
    news: '新闻动态',
    join: '加入新福港',
    quality: '建筑品质',
    contact: '联系我们'
  },
  footer: {
    nav: {
      item1: '人力资源',
      item2: '法律声明',
      item3: '联系我们',
      item4: '骏延湾项目'
    },
    name: '新福港地产有限公司',
    subName: '广州新福港地产置业有限公司',
    address: '地址 : 广州市天河区林和东路285号中汇人寿中心7楼',
    phone: '公司电话 :（86-020）3839 1008',
    copy: 'Copyright © SFK Properties',
    licence: '粤ICP备12092793号-1',
    copyright: '版权所有：新福港房地产（深圳）有限公司'
  },
  home: {
    poster: {
      en: {
        title1: 'SFK',
        title2: 'PROPERTIES'
      },
      cn: {
        title: '细节品质，用心呈现',
        text: '新福港一直努力做好每一个细节，并不断钻研建筑细节对生活品质的提升，创造性地运用设计、\n' +
          '技术和服务，为不同消费者提供理想的生活空间和高品质、高品位的丰盛生活。'
      }
    },
    about: {
      title: '关于我们',
      text: '　　新福港集团是香港著名的楼宇建筑、土木工程及房地产开发公司， 成立于1948年，先后参与多项与香港及澳门发展息息相关的重要工程， 打造了香港汀九桥、东方文华酒店、中环太子大厦、朗豪坊、澳门威尼斯人酒店等多个影响力卓著的城市地标， 以建筑品质享誉业界。<br/>\n' +
        '　　新福港地产为香港新福港集团的全资附属公司，为集团的房地产及物业发展旗舰公司，秉承集团70余年楼宇建设经验及用心建造的优良传统，采用国际性的设计视野，致力打造高素质物业项目；从2004年开始，先后在广州、成都、珠海、佛山、苏州、江门及顺德等城市投资开发了十余项房地产项目，业务遍及珠三角、长三角和西南地区，以提供舒适的居住环境和优越的生活品味为着眼点，以长远回报为目标，专注进取为本，借助香港成功经验为基石，精确地预见性，严谨细致的工作作风和孜孜不倦的努力，成功打造了一个又一个与国际潮流同步的优秀项目。'
    },
    main: {
      title: '主营业务',
      btn: '查看详情',
      text1: '地产项目',
      text2: '酒店管理',
      text3: '商场运营',
      text4: '物业管理'
    },
    news: {
      title: '新闻动态'
    },
    quality: {
      title: '建筑品质',
      ico1: '设计',
      ico2: '规划',
      ico3: '施工',
      ico4: '质检',
      ico5: '服务'
    }
  },
  about: {
    nav: [
      {
        title: '企业概述',
        item: '企业概述'
      },
      {
        title: '品牌介绍',
        item1: '品牌标志',
        item2: '品牌理念'
      },
      {
        title: '发展历程',
        item: '发展历程'
      }
    ],
    info: {
      breadcrumb: '新福港地产有限公司',
      text: '　　新福港集团是香港著名的楼宇建筑、土木工程及房地产开发公司， 成立于1948年，先后参与多项与香港及澳门发展息息相关的重要工程， 打造了香港汀九桥、东方文华酒店、中环太子大厦、朗豪坊、澳门威尼斯人酒店等多个影响力卓著的城市地标， 以建筑品质享誉业界。<br/>\n' +
        '　　新福港地产为香港新福港集团的全资附属公司，为集团的房地产及物业发展旗舰公司，秉承集团70余年楼宇建设经验及用心建造的优良传统，采用国际性的设计视野，致力打造高素质物业项目；从2004年开始，先后在广州、成都、珠海、佛山、苏州、江门及顺德等城市投资开发了十余项房地产项目，业务遍及珠三角、长三角和西南地区，以提供舒适的居住环境和优越的生活品味为着眼点，以长远回报为目标，专注进取为本，借助香港成功经验为基石，精确地预见性，严谨细致的工作作风和孜孜不倦的努力，成功打造了一个又一个与国际潮流同步的优秀项目。'
    },
    brand: {
      breadcrumb: '品牌介绍 ',
      title1: '品牌标志',
      text1: '新福港地产品牌标志由香港著名设计师靳埭强教授设计，此商标重点突出中国独特的瓦片建筑技术，绿瓦栉比鳞次，结构巧妙，加上游鱼象征新福港传承中国传统的优良建筑概念，为现代人提供安逸清幽的居所。',
      title2: '品牌理念',
      text2: '“细节品质，用心呈现。”是新福港品牌的核心理念，也是新福港地产坚持的核心价值观 。70余年来，新福港一直努力做好每一个细节，并不断钻研建筑细节对生活品质的提升，  创造性地运用设计、技术和服务，为不同消费者提供理想的生活空间和高品质、高品位的丰盛生活。'
    },
    history: {
      breadcrumb: '发展历程 '
    }
  },
  main: {
    nav: [
      {
        title: '地产项目',
        list: [
          {
            title: '发展项目',
            item6: '黄埔【新福港·鼎峰】',
            item1: '佛山【新福港·鼎峰】',
            item2: '广州【新福港·鼎荟】',
            item3: '广州【新福港·鼎峰】',
            item4: '成都【御青城度假别墅】',
            item5: '江门【峻廷湾】'
          },
          {
            title: '合作项目',
            item10: '深圳宝安 · 碧海玖号',
            item1: '珠海映晖湾',
            item2: '广州力迅 · T',
            item3: '广州力迅 · 原筑',
            item4: '苏州枫华紫园',
            item5: '苏州未名园',
            item6: '成都领筑国际公寓',
            item7: '成都福字街',
            item8: '广州珠江怡景湾',
            item9: '佛山新红棉大厦'
          }
        ]
      },
      {
        title: '酒店管理',
        list: [
          {
            title: '',
            item1: '酒店管理'
          }
        ]
      },
      {
        title: '商场运营',
        list: [
          {
            title: '',
            item1: '商场运营'
          }
        ]
      },
      {
        title: '物业管理',
        list: [
          {
            title: '',
            item1: '物业管理'
          }
        ]
      }
    ],
    des: [
      {
        title: '地产项目',
        list: [
          {
            title: '佛山 -【新福港·鼎峰】',
            text: '项目位于禅城区发展中轴线魁奇路与汾江南路交汇处，占地约8万平方米，承建一座55万平方米的城市综合体。<br/>\n' +
              '作为佛山首个、也是目前唯一一个双地铁上盖的城市综合体，<b>项目有着无可媲美的交通通达性</b>：<br/>\n' +
              '广佛线及佛山：<br/>\n' +
              '2号线交汇 ，位处连接广佛东西与南北城际通道的核心，3站到祖庙，9站到广州南站，畅通广佛两地；周边路网发达，30分钟接驳广州、5分钟可达佛山各区，2小时可到香港。<br/>\n' +
              '<br/>\n' +
              '屹立于佛山本土，城南核心富人区，周边配套更是齐备； <b>10分钟生活圈内有3大商圈围绕、3大省级名校环绕、2大三甲医院、5个城市公园、2个体育场馆；</b><br/>\n' +
              '作为佛山市中心前所未有的大型优质城市综合体，我们除了外在本已显赫的配套优势，更有内在八面玲珑的美态，新福港·鼎峰，倾力筑造城央精英生活居所：<br/>\n' +
              '<br/>\n' +
              '<b>设计上：</b>\n' +
              '10万平方米的5层商业裙楼和3万方的空中水景园林组成，整个项目将城市居住生活-空中水景园林-缤纷购物天地-地面路网交通-地下地铁快节奏五重生活场景有效串联起来，打破了常规综合体建筑形态的限制，精心打造一种更高级的生活形态。<br/>\n' +
              '<br/>\n' +
              '<b>产品上：</b><br/>\n' +
              '住宅/酒店式公寓、酒店、商场物业形态，由9栋塔楼，包括A1-A6、A9栋共7栋住宅及A7-A8栋2栋酒店式公寓所组成，其中于A7栋23-36层更引进了全球酒店领先品牌---洲际酒店集团旗下的服务型酒店，智选假日酒店进行公寓统一式管理，重新定义佛山优质城市生活。<br/>\n' +
              '<br/>\n' +
              '<b>智选假日酒店进驻：</b><br/>\n' +
              '诞生于1991年的智选假日酒店隶属于全球三大品牌之一，洲际酒店集团旗下的服务型酒店。作为业内发展速度领先的酒店品牌之一，智选假日酒店以物超所值的价格为世界各地的商务旅客和休闲游客，提供高效、简洁、贴心的入住选择。截至2018年第一季度，智选假日酒店在全球拥有2,618家开业酒店，大中华区共有103家开业酒店，分布在全国40多个城市。<br/>\n' +
              '新一代的智选假日酒店定位于佛山禅城繁华区域，填补了这一市场高端酒店定位的空隙；得天独厚的项目优势加上国际星级酒店进驻，代言本地最高标准港式精英生活。未来，这里名流荟萃，出入皆精英名仕，全面提升项目品质，入住率、租金及物业价值也会随之提高，不管是投资、自住、商旅、办公，皆能满足。<br/>\n' +
              '<br/>\n' +
              '<b>三大商圈：</b><br/>\n' +
              '三大商圈围绕，北有禅城区核心商务带——季华路商圈，创意产业园、顺联国际、印象城等大型商业配套；南有佛山最成熟住区——城南商圈，有兆阳广场、惠景书城、丽日商业街等生活型配套；西面有全国规模最大的陶瓷建材商贸圈，佛山陶瓷年总产值超1000亿元。<br/>\n' +
              '<br/>\n' +
              '<b>多所教育名校:</b><br/>\n' +
              '项目周边遍布多所重点学校，10分钟车程均可到达。<br/>\n' +
              '小学：绿景小学（省一级）、城南小学（省一级）、惠景小学（市一级）；<br/>\n' +
              '初中：华英学校（重点省一级）、惠景中学（市一级）、澜石中学（省一级）；<br/>\n' +
              '高中：市三中（国家级示范）、市二中（国家级示范）；<br/>\n' +
              '<br/>\n' +
              '<b>两大三甲级医院:</b><br/>\n' +
              '佛山市第一人民医院（三甲）、禅城中心医院（三甲）<br/>\n' +
              '<br/>\n' +
              '<b>五大公园:</b><br/>\n' +
              '文华公园、亚艺湖公园、季华园、滨江湿地公园、石湾湿地公园'
          },
          {
            title: '广州 -【新福港·鼎荟】',
            text: '在广州城市中心自由穿梭，沿途欣赏着飞机划过天空留下的白色痕迹；约20分钟的行程，从机场到项目，享尽繁华与空间的切换，此情此景，非遥不可及；城央、空港、地铁、高速与人居高度结合的代表作，约24万㎡城市商业综合体正荣耀登场。<br/>\n' +
              '<b>项目位于白云区江府路与广花三路交界，</b>毗邻江高镇政府，为江高镇首个正式房地产开发项目，致力打造成为江高地标性建筑。项目占地约98718㎡，总建面约24万㎡，项目涵盖创意LOFT、精品酒店、时尚商业于一体；集创意办公、商务接待、时尚生活、购物休闲、餐饮美食、精彩荟于一城；将打造为白云区繁华新门户，江高中心新地标。<br/>\n' +
              '<br/>\n' +
              '项目所在为江高镇政府旁，为江高发展的重点位置，<b>距离地铁8号线北延段江府站仅200m，属地铁上盖物业，交通便捷，江府站更是8号线与24号线的更换站。</b>2023年该8号线北段通车后，将与原有的快速路、机场高速等连为一体。立体式交通的网络，必将给客户的生活与产品的升值带来新的高度。<br/>\n' +
              '<br/>\n' +
              '以卓越品质，献予卓越人群，项目设计匠心独运、精雕细琢；共分四期开发，现正处第一期阶段，首批为复式精装LOFT双层公寓，拥有超高使用率；产品面积段丰富，涵盖35m²-80m²面积段，户型从两房到四房，充分满足不同层次的人居需求。<br/>\n' +
              '与城市心脏共同跃动，与人居脉搏相结合；广州江高地标综合项目，以全新视角缔造城市繁华，开启江高商业人居新时代。'
          },
          {
            title: '广州 -【新福港·鼎峰】',
            text: '该项目是新福港地产进驻广州的首个大作，<b>位于广州黄埔区府旁，科学城核心位置，南邻国际配套广州国际演艺中心（NBA篮球馆），北倚善坑顶自然山脉，  占据城市高点，景观视野开阔。</b><br/>\n' +
              '项目远离市区繁嚣却又不失交通便利，<b>紧接6号线萝岗站、公交站点为萝岗中心枢纽总站，家门口的地铁盘和公交首发站，在家门口即可享双线服务，20分钟直达珠江新城。</b>该项目占地面积为12.5万平方米，总建筑面积约29万平方米，规划开发31栋13-31层高层观景洋房，共1600余户，分四期开发。<br/>\n' +
              '<br/>\n' +
              '项目产品类型丰富，涵盖了面积从80-250㎡全系列两至四房，其中主力户型为120-200㎡南北对流舒适三房至宽阔山景四房，打造成广州黄埔区府旁首屈一指的港式半山豪宅。<br/>\n' +
              '<br/>\n' +
              '作为顶尖的高级住宅社区，为筑造独一无二的尊贵生活居住典范，住户可私享两座半山之上，水岸之边的国际艺术会所，广州首个私家画廊，融合了大面积植被水体的高落差台地立体亲水园林和身后的私家山体公园，以及多维的公共艺术空间；同时小区内还设有约三万平方米的配套商业，配备有幼儿园、文化活动站、老人活动中心、肉菜市场、卫生站等设施，为住户提供全方位优质的生活服务。'
          },
          {
            title: '成都 -【御青城度假别墅】',
            text: '坐落于拥有”天下第一幽”美誉的都江堰·青城山风景区，  青城山年平均气温15度左右、森林覆盖率达95%以上。  四季林木茂盛、终年青翠，<b>距离成都市区、双流机场约60公里，青城山快铁站约9公里。</b>景区负氧离子数量达到了22000—31000个/立方厘米，是成都市区的180倍，成为中国大型的天然养生度假圣地。青城山也是著名的道教名山，世界文化遗产、中国文化圣地、国家5A级风景区，其不可复制的自然资源和深沉的人文底蕴相得益彰、举世无双。<br/>\n' +
              '<br/>\n' +
              '御青城泰式风情度假别墅，藏于青城，心之归墅。占地约200亩，以东南亚建筑风格为蓝本设计，并结合青城山独有的地方文化氛围，融入泰式园林艺术，千姿百态的自然水系有序交融，汇成生气盎然的有机脉络，将建筑与自然浑然一体。80-300㎡合院、联排、双拼、独栋，错落有致的点缀在青山秀水中，大露台、私家庭院尽显异域泰国风情。<br/>\n' +
              '<br/>\n' +
              '本项目区别于传统别墅，  它配有度假别墅酒店。  汇集度假、养生、商务于一体，泰式餐厅、泰式SPA和养生馆、室内/室外恒温泳池、水疗按摩池，健身房、瑜伽室、品茗轩、儿童游乐园、会议室等一应俱全。港式酒店管理，住户享受更加全方位的度假生活。'
          },
          {
            title: '江门 -【峻廷湾】',
            text: '峻廷湾与城市商业中心区仅需步行5分钟，被沙坪河环绕，项目占地25万平方米，总建筑面积达57万平方米，首期为纯别墅社区，二、三期规划建设有洋房、商业街、小学及幼儿园。<br/>\n' +
              '<br/>\n' +
              '峻廷湾在项目设计上非常注重建筑与人、建筑与城市、建筑与自然的友好共生，既充分考虑古劳水乡的生态特点，也关注鹤山城市发展的形象需要以及居民生活品质提升的居家需求，充分考虑每一栋建筑、每一种户型的设计均好性，让建筑以谦和的姿态栖居在自然之中。<br/>\n' +
              '<br/>\n' +
              '新福港将峻廷湾项目作为鹤山别墅物业的标杆来打造，在功能配套规划、社区建设、生态景观等方面，以国际级品质为基本要求，致力为鹤山带来前所未有的品质生活，成为鹤山城市发展的里程式标杆。'
          },
          {
            title: '珠海映晖湾',
            text: '项目位置：珠海 <br/>\n' +
              '珠海市前山河旁住宅项目 ─ 映晖湾的构思初衷，就是基于为大家建设一个离城不离市的优美居庭。规划良好的珠海市是广东省内其中一个十分适合安居乐业的城市，而新福港在此发展的映晖湾坐落于当地四通八达的地带，朝南而景观开阔。映晖湾的业主们更可坐享附近小区的成熟配套，邻近还有香洲一小分校、商业街、市场、交通等设施，完善的设施解决了业主们的日常生活所需，让大家安心居住。',
            city: '珠海'
          },
          {
            title: '广州力迅·T',
            text: '项目位置：天河区黄埔大道，翠湖街交汇处<br/>\n' +
              '占地面积：6495.80平方米　/　总建面积：45286平方米。<br/>' +
              '主推精致小户型，布局合理、采光充足、设计简约、功能齐全，整体舒适度极高，属于珠江新城一带性价比高的物业。<br/>\n' +
              '周边配套成熟，拥有国际化生活社区，处于天河公园板块，靠近华南快速干线、黄埔大道中，出行十分方便，5分钟可到达各大型商业购物中心。',
            city: '广州'
          },
          {
            title: '广州力迅·原筑',
            text: '项目位置：花地大道西，坑口地铁站和西朗地铁站之间。<br/>\n' +
              '园林面积：约1.5万平方米　/　总建面积：约9.4万平方米<br/>\n' +
              '简约中带古典建筑风格，予人以优雅。多样的户型，配以不同风格的设计，成为独具慧眼的单身贵族及小康之家的理想家园<br/>\n' +
              '地理位置优越，交通脉络汇集，位处芳村的新商圈中心地带，不仅周边配套完善，且小区内自设三层独立会说、大型泳池等均让住客四季皆体验生活的壮美。',
            city: '广州'
          },
          {
            title: '苏州枫华紫园',
            text: '项目位置：苏州市吴中区金枫路东侧<br/>\n' +
              '占地面积：约8.4万平方米　/　总建面积：约30.6万平方米　/　绿地率：约53%<br/>\n' +
              '整个小区采用了简约的建筑风格，在建筑立面的造型、色彩及户型的设计上体现了浙建地产一贯地追求合理、舒适的理念，' +
              '并融入了苏州的文化脉络，使整个建筑平和、自然的融入到社区的整体环境中。',
            city: '苏州'
          },
          {
            title: '苏州未名园',
            text: '项目位置：位于苏州市吴中区浦庄镇浦庄大道<br/>\n' +
              '占地面积：约7万平方米　/　总建面积：约4.6万平方米<br/>\n' +
              '未满足未名园业主对生活品味的追求，建筑师以充满优雅东方韵味的装饰，衬托简约时尚的西方建筑，使每一所房子都是文化的结晶' +
              '<br/>\n' +
              '位于优越的太湖板块，拥有弥足珍贵的山水人文资源，更被著名旅游景点环抱，包括农林大世界、东山风景区、苏州太湖国家旅游度假区等，大自然' +
              '就在离家门口不远之处。',
            city: '苏州'
          },
          {
            title: '成都领筑国际公寓',
            text: '项目位置：位于成都市中心的文翁路与金盾路交汇处<br/>\n' +
              '毗邻天府广场、人民公园。宽窄巷子、武侯祠、锦里、耍都及琴台路均处于楼盘周边。<br/>\n' +
              '距春熙路1公里、距机场16公里、火车站5公里，步行可至地铁一、二号线天府广场站、人民公园、天府广场等繁华地段，周边景点云集,交通便捷、购物方便、闹中带静，配套成熟，休闲、娱乐、商务、生活于一身，独擅城央地利之优',
            city: '成都'
          },
          {
            title: '成都福字街',
            text: '　　家在市区的繁华地段，日常的便利已经是唾手可取，时尚之物触目皆是，多姿多彩的生活更时刻显得璀璨；卜居于成都黄金核心区新建构的福字街项目，固然拥有以上一切，还可兼得旧城特色和时代气息迸发的生活新火花。<br/>\n' +
              '　　福字街项目位于成都市中心锦江区福字街与书院南街交汇处，紧邻锦江区政府和商业核心区居室内最繁华的商业步行街「春熙路」仅百米之遥，地理位置优越。这座高级商住楼位于区内兴旺的地段，却多了一分宁静的氛围，提供理想的高品位生活，提现不一样的居住、生活和消费乐趣。家门内，你可以投入高雅时尚的生活享受；家门外，你可找到街坊式的亲切感和传统市镇的情怀，经常获得崭新的体会和发现。<br/>\n' +
              '　　春熙路是成都最具代表性、最繁华热闹、历史极为悠久的步行街，此处的商贸业极为发达；儿由总府路以南、上东大街以北、红星路以西和盐市口以东组成的春熙路商圈，是成都老城区三大商圈之一。座落于春熙路附近的福字街项目，是政府的一级重建项目，旨在将它打造成地标式都市景观区域，并使之成为市中心商业区的延伸。<br/>\n' +
              '　　随着福字街项目的开发，换上新面貌的成都将更闪更亮，而居于此处的生活格调将会加倍时尚精彩。\n'
          },
          {
            title: '广州番禺珠江怡景湾',
            text: '项目位置：番禺大石镇华南快线番禺大桥侧，<br/>\n' +
              '占地约120,000平方米，建筑面积达210,000平方米，周边还有其他著名住宅及别墅项目，区内并有超市、幼儿园等，生活配套完善，属番禺区内开发较早的成熟小区之一。理想的居所，除了讲究优美的地理环境和完善的配套设施外，还要求有卓越的发展潜力。在番禺房地产发展项目的选址上，除了周边小区发展成熟的配套外，我们更看重政府在该区的发展蓝图。'
          },
          {
            title: '佛山新红棉大厦',
            text1: '走在顺德区，马上感觉到热闹兴旺的氛围。于顺德区的服务式公寓，毗邻\n' +
              '新世界中心商场及市内唯一国际4星级的新世界万怡酒店；荟萃閒情逸致的华盖\n' +
              '路商业购物街和多个大型商场；以及广东四大名园之一、以岭南庭院古朴风格而\n' +
              '著称的清晖园。座落于这个黄金地段的顺德区服务式公寓，处处盈满精彩生活元\n' +
              '素，簇拥天赋的繁华优势。<br/>\n' +
              '置身高雅舒适的生活空间，身心自必閒逸舒泰。新红棉大厦由新加坡规模\n' +
              '最大的著名建筑设计公司之一 —— DP  Architects负责整体规划及建设，约\n' +
              '28,000平方米的总建筑面积之内，一隅一角均凝聚建筑师及设计师的巧妙创意\n' +
              '和心思。',
            text2: '以小户型为主的单位设计，室内时尚雅致，崇尚简约高洁，呼应单身贵族或新婚两口子的现代生活态度。当然，他们的写意体验亦备受重视,居住区内除了提供酒店式服务之外，也设有泳池和健身室等配套，加上一至四层为购物中心，既带来消閒乐趣，也满足日常需要。此项目不仅拥有享受之利，更位处城市枢纽核心，别具交通之便。从这裡前往顺德港码头仅20分钟车程，往广州白云机场只需1.5小时车程。而即将全面开通的珠江三角洲西岸干道，将成为一条直接连繫广州、顺德、中山及珠海之高速公路系统，穿梭于国内各地自是随心所欲。顺德服务式公寓绽放独特的风度情緻，勾勒出时尚都市的新面貌，必能让您幸福涌动。'
          },
          {
            title: '黄埔 -【新福港·鼎峰】',
            text: `
                    　　黄埔新福港鼎峰是新福港在广州黄埔区继萝岗新福港鼎峰后的又一力作，
                    它将再次定义新福港打造标杆社区的<b>人居新高度，黄埔新标杆</b>。<br/>\n
                    　　项目位于广州开发区核心区域，毗邻省一级小学广州开发区二小，
                    距离地铁5号线东延线黄埔新港站仅约5分钟，交通便利。未来实施西区振兴计划，
                    打造世界制造业总部经济区、海丝国家免税贸易区，项目将成为广州开发区西区转型升级的典范之作。<br/>\n
                    　　<b>匠心规划，功能齐全</b>，在社区生活功能规划上，项目独具匠心，
                    将3F、14F架空层打造成全维生活动区，不仅设有无边际泳池、乒乓球区、少年篮球区等运动设施，
                    还规划有艺术绘画区、阅读区、儿童乐园等休闲场所，满足家庭全龄生活需求。<br/>\n
                    　　项目临近东江北支流，坐拥景观资源，88-130方三至四房舒适型产品，
                    大阳台，大飘窗，全屋窗比超50%，明亮宽敞，打造高舒适性居住新产品。<b>高层全江一览，打造不一样的鼎峰</b>。`
          },
          {
            title: '深圳宝安 -【碧海玖号】',
            text: `
                    　　项目位于前海合作区，充分发挥核心引擎作用，享有海陆空铁轨五维交通体系，<br/>\n
                    快速连接全球；项目距离11号线碧海湾站500米，15分钟直达机场/宝中，20分钟至前海，25分钟到南山中心。<br/>\n
                    　　通过与南山、福田的协同发展，提升宝安中心区及周边南部地区的整体能级。<br/>\n
                    　　项目位于“<b>宝安中心区及大铲湾片区</b>”，处于前海“一心一带双港五区”中的核心——前海城市新中心。<br/>\n
                    　　提升全球资源配置能力，推动总部、贸易、服务和会展经济发展，打造湾区“<b>国际会客厅</b>”，潜力巨大。<br/>\n
                    　　项目位于⻄乡街道铜⿎堡路与宝瑰路交界东侧，距离11号线碧海站500m，占地：4.16万㎡， 总建面：14.21万㎡， 容积率：2.2。
                    其中，住宅7.9万㎡，商业4900㎡，公寓4900㎡，幼儿园2200㎡，地块限高90m，推售户型：106-186㎡4-5房。
                    `
          }
        ]
      },
      {
        title: '酒店管理',
        list: [
          {
            title: '御青城度假别墅酒店',
            text: '青城山——全球道教主流教派全真道圣地，世界5A级双遗产，中国四大道教名山之一。<br/>\n' +
              '<br/>\n' +
              '御青城度假别墅酒店坐落于拥有“天下第一幽”美誉的青城山。由香港新福港集团投资按星级标准兴建，打造都江堰首席泰式文化主题酒店。是一家集商务、会议、度假、康养功能为一体的度假别墅酒店。<br/>\n' +
              '<br/>\n' +
              '酒店装饰宏伟大方，内部装饰流金溢彩，相得益彰，是融合泰国风情与青城文化的完美结晶。酒店设施齐全，服务项目众多，餐饮设施有泰国创作料理餐厅、大堂吧、露天烧烤吧。酒店还有配有多功能会议室、室内恒温泳池、室外泳池、健身房、台球室、水疗按摩池、儿童游乐、品茗轩等设施。酒店采用星级港式酒店管家服务，提供定制旅游、商务、生活、度假等服务，致力为宾客提供奢华舒适的泰式生活度假享受。'
          }
        ]
      },
      {
        title: '商城运营',
        list: [
          {
            title: '“新·DNA”购物中心',
            text: '新福港地产在佛山首个匠心之作 “新•DNA” 大型城市综合体项目，位于佛山市禅城区魁奇路与汾江南路交汇处，广佛地铁1号、2号线换乘点，双地铁上盖，魁奇路地铁站C出口与购物中心无缝衔接。<br/>\n' +
              '新.DNA购物中心总面积10万平方米，将成为佛山一个新地标。汇集国际快时尚品牌，其中更有多个品牌首次进驻佛山。主力品牌AEON超市。MELAND儿童乐园、ADIDAS、周生生、六福珠宝、麦当劳、香港翠华餐厅、星美国际影城等，为佛山带来新的历奇体验式购物时尚天地。'
          },
          {
            title: '新·DNA 理念',
            text: '1 新地标<br/>\n' +
                  ' （1）超高层城市地标建筑<br/>\n' +
                  ' （2）双地铁无缝对接，2700个车位<br/>\n' +
                  ' （3）集购物中心、住宅、公寓、酒店、枢纽中心<br/>\n' +
                  '2 新体验<br/>\n' +
                  ' （1）全业态 、全龄层，精心打造欢乐消费之旅<br/>\n' +
                  ' （2）巨资打造历奇天地，惊喜无限<br/>\n' +
                  ' （3）汇聚世界美食，打造舌尖上的佛山<br/>\n' +
                  '3 新汇聚<br/>\n' +
                  ' （1）佛山单层面积最大的永旺超市<br/>\n' +
                  ' （2）3D巨幕影院及特设儿童厅引爆潮流<br/>\n' +
                  ' （3）强强联袂，势在登顶'
          },
          {
            title: '新·DNA 主题',
            text: '缤纷邮轮 ——  随时开启多彩“旅途”<br/>\n' +
              '科幻历奇  —— 突如其来的“惊喜”<br/>\n' +
              '灯塔冒险  —— 一起放声“欢笑”'
          },
          {
            title: '新·DNA 购物中心',
            text: '佛山得天独厚的优越地理位置，<br/>\n' +
              '新·DNA拥祖庙商圈、<br/>\n' +
              '佛山新城商圈、季华商圈、桂城商圈，<br/>\n' +
              '四大主力成熟商圈，完美辐射100万人口。<br/>\n' +
              '广佛地铁进一步深化广佛同城，<br/>\n' +
              '未来人流量，不可限量。'
          }
        ]
      },
      {
        title: '物业管理',
        list: [
          {
            title: '物业管理',
            text: '　　佛山新福港物业管理有限公司（原名：佛山宝得物业管理有限公司）成立于2010年9月，是一家具有国家三级资质的外商独资企业，隶属于香港新福港集团，在香港证券交易所上市。\n' +
              '因业务发展需要，公司分别在2011年和2016年依法注册成立了江门分公司和广州分公司，并于2017年依法注册成立了广州子公司。\n' +
              '为规范公司的发展，公司先后加入佛山房地产协会和江门物业管理协会，并取得ISO9001:2008的国际质量标准认证。\n' +
              '为打造优质物业服务品牌，汲取国际物业管理经验，公司曾与香港鹰君集团和世界五大行“高力国际”合作，力求用专业、规范、酒店式的标准，用心为客户提供每一项服务。\n' +
              '迄今为止，公司为客户提供的服务包括早期介入顾问服务、销售案场服务、前期物业服务以及前期物业服务顾问服务。公司服务项目位于广州、佛山、江门、成都等地，服务类型有别墅、高层住宅、会所、商业、城市综合体等。'
          }
        ]
      }
    ]
  },
  news: {
    nav: [
      {
        title: '新闻动态',
        item: '新闻动态'
      }
    ],
    list: [
      {
        breadcrumb: '新闻动态 ',
        text: ''
      }
    ]
  },
  join: {
    nav: {
      title: '加入新福港',
      item1: '企业文化',
      item2: '人才理念',
      item3: '岗位招聘',
      item4: '招聘声明',
      item5: '法律声明'
    },
    culture: {
      title: '企业文化 ',
      list: [
        {
          text: '<p class="title">始于1948年的细节品质   源自几代人的处处用心</p>'
        },
        {
          text: '<p class="text">新福港集团是香港著名的楼宇建筑、土木工程及房地产开发公司，成立于1948年，参与了多项与香港及澳门发展息息相关的重要工程，以细节品质享誉业界。\n' +
            '作为一家拥有多年建筑经验和多个港澳城市地标建设经验的知名企业，新福港集团始终秉承‘给社会最好的建筑’的企业信仰，坚持做好每一处细节成为其永不放弃的梦想与追求。时至今日，文华东方酒店、中环太子大厦的坚固如初，汀九大桥的精确施工，朗豪坊的建筑选材，迪士尼好莱坞酒店的七星级酒店标准施工建造，威尼斯人会议展览中心的高规格验收标准~~无不成为建筑业界的经典传奇。\n' +
            '新福港地产是新福港集团的全资附属公司，为集团的房地产及物业发展旗舰公司，现时的房地产项目遍及珠三角、长三角及西南地区。新福港地产拥有国际性的设计视野，传承60余年精工品质建造经验，封顶目的用料和结构建造尤其重视，致力打造一个又一个内外兼备的高素质物业项目，成就高品质、高品位的新经典、新传奇。</p>'
        },
        {
          text: '<p class="text">新福港是一家优秀、传统的企业,秉承着创始人罗啓瑞先生待人接物的理念:用尽心思做足功课,服务客户至极致。\n' +
            '多年的建筑经验告诉我们,产品细节才是建筑的价值所在。新福港善于捕捉和钻研一些很细微但却能令生活提升的元素,我们尝试按每—位潜在客户的个性需求来订造产品,我们倾尽所能为所有欣赏生活艺术的用户,提供舒适又优质的生活环境,匹配他们对生活品味的追求,启迪人生,令生活更趋美满。</p>'
        },
        {
          text: '<p class="text">新福港创办至今,业务发展理念和企业文化都是以人为本，以生活中心，以社会价值最大化为己任。我们位于亚洲的多项建筑工程，以及在中国内地的房地产项目,均是从人性根源需求岀发,以塑造更趋美满的生活为企业社会责任。\n' +
            '新港在社区规划、产品设计、用料选择、建造施工、质量管理、物业服务等房地产开发的各个领域，均拥有经验丰富的专业团队，其中不少员工在公司服务10年以上。每一个新福港员工,都恪尽本份,怊守专业精神和企业道德。如果我们每天所的工作，就算只是为这世界带来一点点的贡献，那都让我们倍感快慰。</p>'
        },
        {
          text: '<p class="text">新福港在各主要房地产及物业开发项目的选址上均经过细意考量，务求达到生活既被苍翠的大自然环抱，又具备二十一世纪都市的先进设备及咫尺之隔的便利。\n' +
            '在进行项目分析的时候，我们会详细了解和评估项目所处的位置、自然环境、人文景观、消费需求，以及城市发展对项目的需求,注重人文素养在建筑中的体现。我们尝试站在客户的角度来规划项目,考虑到他们对环境、对空间、对生活、对肚交等各个方面的期望，创造更为理想、和谐的美满生活。我们会打造一个独一无二，并目契合那里的建筑。</p>'
        },
        {
          text: '<p class="title">品质决定价值!\n<br/>' +
            '你看得见的好房子</p>' +
            '<p class="text">新福港·鼎峰的质量管理团队，是香港眀豪坊与迪士尼工程的质量管理团队的原班人马，他们管理的流程与标准，都比内地现有的标准要严格，为了保证质量把关的公正严谨,他们的所有工作都需要直接向香港集团总部进行汇报。无论从住户看到还是看不到的层面，他们都十分关注细节，精雕细琢。\n' +
            '行业人士都知道，一个楼盘项目，最为棘手显眼的问题就是漏水。为了杜绝这个问题，鼎峰在选择窗框材料时全部都使用压力枪进行测试；在厕所环境建设中会做24小时浸水测试,以避免收楼后的房屋渗漏。\n' +
            '而在住户看不见的方面，新福港·鼎峰也执着追求精益求精。例如,鼎峰楼板厚于一般的建筑楼板,以更好地避免上层走动、活动声音影响到下层用户的生活;鼎峰采用了25米/秒的电梯，这是高于萝岗大多数楼盘采用的1.8-2米/秒的上升速度，为住户节约不少时间；一般楼盘的30层建筑均采用管椿,而即便是17层的小高层楼体,鼎峰也采用成本更高、但更安全的衝孔灌注桩；国家标凖的打桩λ岩深庋是30cm；而鼎峰的标凖是入岩深度达到100m。</p>' +
            '<p class="title title2">为了建筑多照1小时太阳,\n<br/>' +
            '我们将设计改动57次</p>' +
            '<p class="text">广东佛山新福港广场项目，是新福港地产在大陆开发的第一个地铁上盖城市综合体。新福港考察了国内外多个知名商业项目，并委托第\n' +
            '太平戴维斯进行深入的市场调查，还聘请了三家擅长商业规划的顾问公司：第一太平戴维斯、恒昌、华夏柏欣，参与该项目的商业定位工作。\n' +
            '通过对三家公司的方案进行反复的比较论证，综合各家所长，最终才确定佛山新福港广场项目的商业定位方案。而在佛山新福港广场项目的开发过程中，新福港与阳光玩了一个小游戏。作爲包括商业和住宅的城市综合体项目，新福港对日照有着区别于普通住宅建筑的要求，同时，中国人沿袭了几千年的居住习惯，也对阳光有着异乎寻常的偏好和喜爱。\n' +
            '新福港广场项目建筑设计的初稿，在“日照”这一指标上与公司制定的标准相比少了一点。这也许衹是一件小事,但在新福港眼中却是\n' +
            '件大事。为了让建筑享受到更多的阳光，新福港设计部门的员工经过数十个昼夜,上百次讨论,57轮修改……终于，新的设计稿通过了。</p>'
        },
        {
          text: '<p class="text">建材对于建筑犹如一个人的骨骼和血肉，优质的建材才能使建筑健康长久地使用。新福港对于选材，有一整套完整而严谨的体系。通常我们会根据一套严格的步骤去评核不同物料的供货商。并实地考察他们的工厂，对他们的规模、技术和信誉有信心，才向他们采购。对于钢材和混凝土等主要建材,，我们会比一般条例要求或者行内习惯提出更高的质量要求,做更多和更频密的样板测试。从我们的专业经验来说，符合标准不一定等于安全可靠，从工程开始到结朿,我们会在施工中进行反复测试,对项目的结构有所掌握,工序因而更繁复,成本也更高，但这正是新福港的专业性和企业道德所在。</p>'
        },
        {
          text: '<p class="title">严格的选材标准，让建筑品质赢在起点</p>' +
            '<p class="text">朗豪坊的设计概念是“石头之城”，所用石材全部来自巴西一个从未经采用的石矿，为的是确保在朗豪坊之前没有别的建筑用过这个纹理的石头。从石矿送来的石材，新福港要确保它们都是高质素的，亦要做测试，确保石材的硬度足够，受压能力亦能达到朗豪坊的建设标凖。此外，石材的大小和顔色等都有严格的要求，设有顔色标凖来做比对。\n' +
            '朗豪坊有一个很大的钢结构部分，其中包括支撑一个楼底跨度逹ω米的中庭，新福港选用了来自日本的钢材，虽然价钱较贵，但由于那些日本钢材制造的时候误差十分低，这就能确保钢结构的稳固。</p>' +
            '<p class="title title2">一个跨越万里、价值20万美元的测试</p>' +
            '<p class="text">新福港在施工过程中，会把项目可能面对的种种极端情况都考虑到，进而在建设过程中采用相应的解决办法。新福港集团承建的澳门威尼斯人会议展览中心项目，总楼面面积达13万平方米。在建造过程中，除了反复做不同的检验程序外，在澳门威尼斯人会议展览中心的上盖正式装上前，我们将部分材料送往美国做测试，确保它的防水、防风、受力及结构坚固程度等。这测试花了20万美元,爲的是要达到国际级的标准。</p>'
        },
        {
          text: '<p class="text">新福港认为，再宏伟的设计构想，如果不赋予—个严谨到苛刻的建造过程，再好的设计也没有成为现实的可能。新福港在香港就以工程质量莕称，在建造全过程，都以苛刻的标准要求自己，只为城市、为城市中的人建造岀优质的产品。\n' +
            '在建筑过程中，我们与设计师紧密联系,每—个细节做了很详细的施工图，确保每个部都是准确无误。每道工序都有严谨的规划，确保项囯施工有条不紊进行。\n' +
            '如果需要赶工，我们也绝不会牺牲质量，而是思考新的建造方法，用更短的畤间去达到要求。为了保证公司于内地开发的每一个项目的品质，新福港特地从香港抽调具有多年饯工作经验的工程人员,组建了新福港施工旵质监管团队,与工程监理单位密切配合，在工地—线进行现场监督，为项目工程品质上了双保险。</p>'
        },
        {
          text: '<p class="title">整整一仓库的图纸资料，见证朗豪坊严谨的建造过程</p>' +
            '<p class="text">在朗豪坊建造过程中，施工安全是一个极大的挑战。旺角地区人口密集，如果施工不慎发生材料或工具坠落，后果不堪设想。所以我们毎一个步骤都十分谨慎，与美国捷得建筑师事务所紧密配合，不断进行设计修正，确保工程有效率而且安全。设计师为朗豪坊设计了一个“山洞”，用石头砌成很多不规则的墙身组合十分重要，新福港必须要硏究岀可行的方法，\n' +
            '确保能符合政府的结构要求。新福港在墙身底部増加做了一层防水处理，以便将设计师的图纸细化成不同的工作部分，确保能做到预期的设计效果。此外，用来装设石材的支架，新福港花了很多功夫去计算，以确保墙面的稳固。事后在整理图纸资料时发现，朗豪坊的设计图纸堆满了整整一个大仓库，完全可以做一个专题固书馆。</p>'
        },
        {
          text: '<p class="text">新福港对每一工程都力求完美，凡事心身体力行，以超过65年的精工经验和专业的建筑品质，打造每—栋建筑。新福港深信，建筑是—种文化的表现，而新福港的岀品，则是新福港文化的呈献。新福港以专业的建筑技术，让建筑物的内在文化和意蕴得以流露，把美感、人文关怀融入建筑当中,让身处建筑的每一个人,都能感受新福港的用心。而整个工程每部分的每个细节体验上，新福港都把它们交给最专业的人来做，从而在每细节上都能做到最好，这样才能打造出整体完美的建筑。材料选取、规划设计、园林打造、物业管理等各项工作,都与人居息息相关，新福港礼聘国际知名、专业的公司服务，精工细作，专业荟萃，只为打造完美的建筑，完美的人居。</p>'
        },
        {
          text: '<p class="title">“1+1双保险合作模式”\n<br/>' +
            '国际化理念与中国居住文化的结合</p>' +
            '<p class="text">要做好一个项目，就得选择好的合作伙伴，新福港地产基本上只考虑与行业排名前十位的公司合作。在总体规划、交通、园林消防、设备、结构、装修等设计方面，均采用“1+1”的合作模式，选择1家国际公司做顾问，同时选择1家国内公司做执行。以保证我们的项目既具备国际化设计视野，又能符合国内消费需求。正如同家长给孩子选择名师一样，新福港地产愿意花更多的项目费用，就是爲了能让我们的项目赢在起点，不输在未来。</p>'
        },
        {
          text: '<p class="text">新福港以香港商业物业的管理标准，秉承在朗豪坊、花旗银行广场、鹰君中心等高档物业管理中积累下来的尊贵服务经验，带来更好的体验和享用，让业主的生活从此与众不同。\n' +
            '新福港不断钻研与业主生活相关的一些服务细节，竭力帮助业主去提升生活。从业主生活的方方面面去考虑，我们越用心，业主就越省心，我们多做好一个细饰，就为业主多创造一份生活价值。\n' +
            '在新福港看来。服务不仅是物业管理职责所系，更应该注入—份互助与关怀的人文情感。我们期望，通过我们的用心工作，家能成为正您一天辛勤工作之后的安乐窝，更是您与爱侣、至亲共度甜蜜时光的美好天地。</p>'
        },
        {
          text: '<p class="title">交楼，交给客厂全部管图,\n<br/>' +
            '才是为客户思考周全</p>' +
            '<p class="text">许多开发商的做法是：将房子钥匙漂漂亮亮交到客户手中，就算是完事了。但新福港在这一方面为客户想得更多，想得更细。\n' +
            '房子以后的维护保养，很多时候都需要管线图，客户需要知道房子管的布局。新福港注意到了这个细节，在交楼那一刻，就将房子的全部管线图一并交给客户，如此贴心，没有细微的洞察和周全的思考，是很难做到的。</p>'
        },
        {
          text: '<p class="title"></p>' +
            '<p class="text"></p>' +
            '<p class="title title2"></>' +
            '<p class="text"></p>'
        }
      ]
    },
    idea: {
      title: '人才理念',
      text: '　　重视人才是新福港的企业哲学，公司尊重每一个员工的辛勤付出，珍惜与每一个员工在工作中建立起来的宝贵情谊。<br/>\n' +
        '公司鼓励员工将个人追求融入公司长远发展之中，创造公平的工作平台和积极的工作氛围，使员工在企业发展过程中实\n' +
        '现个人理想，创造职业价值。<br/>\n' +
        '　　我们认为成功并不在于财富，而是建基于提升生活与达成梦想的喜悦。新福港要凝聚一批有生活梦想和激情的人，恪守本份，竭力帮助我们的客户去提升生活。\n' +
        '我们深愿能为每一位员工带来奇妙的人生旅程，成就事业并获得心灵满足。'
    },
    statement: {
      breadcrumb: '招聘声明',
      title: '声明函',
      text1: '各位应聘者： <br/>\n' +
        '　　为防止不法分子假冒我公司名义在网上招聘的情况，本公司就此事项声明如下：<br/>\n' +
        '　　一、本公司及各项目公司从未以任何形式、任何途径向应聘者发出赴外地培训或收取任何费用等信息；<br/>\n' +
        '　　二、本公司及各项目公司的招聘信息以公司网站www.sfkp.cn和前程无忧网站www.51job.com对外公布的信息为准；<br/>\n' +
        '　　三、本公司对外公布的招聘联系人及联系方式为：',
      text2: '　　联系人：孙小姐； <br/>\n' +
        '　　公司总机电话：020-3839 1008；传真：020-3839 1905；<br/>\n' +
        '　　E-mail: gz@sfk.cn；　　邮编：510610；<br/>\n' +
        '　　地址：广州市天河区林和东路285号天安人寿中心7楼',
      text3: '　　敬请大家提高警惕，谨防上当受骗，以免造成各种损失。本公司将收集证据并保留通过法律途径维护我公司合法权益的权利。同时保留对不法分子追究法律责任的权力。 <br/>\n' +
        '　　特此声明！',
      text4: '新福港地产有限公司 <br/>\n' +
        '                                                               二O一八年七月二十日'
    },
    position: {
      breadcrumb: '岗位招聘',
      title: '广州新福港地产置业有限公司作为新福港集团房地产业务在内地的主要运作平台,为适应公司业务不断发展的需要,现高薪诚聘各方精英加盟。',
      email: '投递简历',
      des: '职位描述',
      pay: '薪资范围',
      person: '招聘人数',
      yuan: '元',
      ren: '人',
      name: '姓名',
      mobile: '电话',
      levelWord: '留言',
      position: '投递岗位',
      path: '上传附件',
      file: '选择文件',
      uploadTip: '只能上传doc/docx文件，且不超过5mb',
      select: '请选择',
      submit: '提交',
      reset: '重置',
      sending: '邮件发送中',
      sengdEmail: '接收邮箱',
      duty: '岗位职责'
    },
    legal: {
      breadcrumb: '法律声明',
      title: '法律声明',
      text: '　　未经新福港地产有限公司书面许可，本网站浏览者不得以任何方式分发、改动、传播或使用本网站的内容作公开或商业用途。本网站一切内容及资料，只可下载作非商业用途或供个人使用。在任何情况下，如未经新福港地产有限公司书面许可，任何人不得使用本网站所涉及的任何知识产权。<br/>\n' +
        '<br/>\n' +
        ' 免责声明：<br/>\n' +
        '<br/>\n' +
        '　　新福港地产有限公司对网站所包含之信息的准确性不作任何保证，您在使用和浏览网站时须完全自负风险。对于因网站上不准确或不正确的任何信息给您造成的损失或损害，新福港地产有限公司不承担任何赔偿责任。本网站所有内容仅为示意说明，有关住宅楼盘的一切信息均以政府有关部门最后批复及正式签署的《商品房买卖合同》记载为准。<br/>\n' +
        '<br/>\n' +
        '　　在任何情况下，新福港地产有限公司均不对因使用本网站或任何其它被超级链接的网站而导致的任何直接的、间接的、特别的或其它后果性的损害承担赔偿责任，包括但不限于任何利润损失、业务中断、程序丢失或您的信息处理系统或其它设备上的数据丢失等，即使我们已被明确告知存在发生这些损害的可能性。网站所含的信息可随时更改或修订，而无须也无义务发布事先通知。<br/>\n' +
        '<br/>\n' +
        '　　新福港地产有限公司及本网站所陈述的公司及个人，无须为本网站所载的任何错漏负责，并保留权利做出修改而无须事先通知。上述人士无须对本网站或其所载资料的使用或提述负责，亦无须就任何由本网站或其所载资料引起的或与之有关的损失承担责任。'
    }
  },
  contact: {
    nav: {
      title: '联系我们',
      item1: '联系我们'
    },
    info: {
      breadcrumb: '联系我们',
      title: '新福港地产有限公司 ',
      text: '地址：广州市天河区林和东路285号天安人寿中心7楼<br/>\n' +
      '邮编：510610<br/>\n' +
      '电话：（86-020）3839 1008<br/>\n' +
      '传真：（86-020）3839 1905<br/>\n' +
      '电邮：gz@sfk.cn'
    }
  },
  quality: {
    nav: {
      title: 'SFK品质',
      item1: '设计',
      item2: '规划',
      item3: '施工',
      item4: '质检',
      item5: '服务'
    },
    design: {
      breadcrumb: '设计',
      text: '　　新福港在各主要房地产及物业开发项目的选址上均经过细意考量，务求达到生活既被苍翠的大自然环抱，又具备二十一世纪都市的先进设备及咫尺之隔的便利。<br/>\n' +
        '<br/>\n' +
        '　　在进行项目分析的时候，我们会详细了解和评估项目所处的位置、自然环境、人文景观消费需求，以及城市发展对项目的需求，注重人文素养在建筑中的体现。<br/>\n' +
        '<br/>\n' +
        '　　我们尝试站在客户的角度来规划项目，考虑到他们对环境、对空间、对生活、对社交等各个方面的期望，创造更为理想、和谐的美满生活。'
    },
    buy: {
      breadcrumb: '规划',
      text: '　　在新福港，规划是对生活的全面思考，我们不光是创造建筑，更多的是在创造生活。<br/>\n' +
        '<br/>\n' +
        '　　生活应该有快乐的一面，生活应该有甜蜜的一面，生活还有温馨的一面。建筑规划，呈现幸福生活方方面面。'
    },
    work: {
      breadcrumb: '施工',
      text: '　　新福港在香港就以工程质量著称，我们认为，再宏伟的设计构想，如果不赋予一个严谨到苛刻的建造过程，也没有成为现实的可能。<br/>\n' +
        '<br/>\n' +
        '　　在建筑过程中，我们与设计师紧密联系，每一个细节做了很详细的施工图，确保每一个细部都是准确无误。每一道工序都有严谨的规划，确保项目施工按计划有条不紊进行。如果需要赶工，我们也绝不会牺牲质量，而是思考新的建造方法，用更短的时间去达到要求。<br/>\n' +
        '<br/>\n' +
        '　　为保证公司于内地开发项目的建筑品质，新福港特地从香港抽调具有多年一线工作经验的工程人员，组建了新福港施工品质监管团队，在工地一线进行现场监督，与工程监理单位密切配合，为项目工程品质上了双保险。 '
    },
    test: {
      breadcrumb: '质检',
      text: '　　在新福港，质量检测贯穿项目建设的始终，是新福港永久工程标准中重要的一环。<br/>\n' +
        '<br/>\n' +
        '　　对于每一样建材，我们要求供应商提供权威检测机构出具的质量合格证明或样本检测报告，并对重要的建筑材料进行抽样检测，确保建材符合质量标准。<br/>\n' +
        '<br/>\n' +
        '　　从我们的专业经验来说，符合质量标准不一定等于安全可靠，所以我们还会在施工中进行反复测试，对项目的结构有所掌握。'
    },
    serve: {
      breadcrumb: '服务',
      text: '　　新福港地产注重服务品质带给消费者的体验，处处悉心，以港式尊贵服务标准，带给客户更多感动。<br/>\n' +
        '<br/>\n' +
        '　　在销售接待服务中，我们站在客户角度换位思考，提前做好客户接待预案，以保证客户在咨询、选购、签约、收楼等过程中都能舒心顺利。<br/>\n' +
        '<br/>\n' +
        '　　我们特意聘请香港鹰君物业作为新福港地产的物业服务顾问，确保管理标准化和服务规范化，按五星级酒店服务标准制定项目物业服务方案。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js